import {
  AllFeedback,
  AllFreeformAnswers,
  AnswerSource,
  Feedback, FreeformAnswer, Question, QuestionStats,
  SurveyAudienceCriteria, SurveyQuestionType, SurveySummaryQuestion,
} from "../../redux/survey/survey.types";
import { CombinedQuestionStats } from "./view-survey.types";

const { AI, All, Human, RTR } = AnswerSource;
const convertCriteriaToList = (criteria: SurveyAudienceCriteria): string[] => {
  return Object.entries(criteria).flatMap(([key, value]) => {
    return (value as string[]).map(val => `${key}: ${val}`);
  });
};

const feedbackListForFilter = (feedback: AllFeedback, sourceFilter: AnswerSource): Feedback[] => {
  const { aiAnswers, humanAnswers, rtrAnswers } = feedback;

  const allFeedback: Feedback[] = [];
  const showHuman = sourceFilter === All || sourceFilter === Human;
  showHuman && allFeedback.push(...humanAnswers);
  const showAI = sourceFilter === All || sourceFilter === AI;
  showAI && allFeedback.push(...aiAnswers);
  const showRTR = sourceFilter === All || sourceFilter === RTR;
  showRTR && allFeedback.push(...rtrAnswers);

  return allFeedback;
};

const freeformListForFilter = (answers: AllFreeformAnswers, sourceFilter: AnswerSource): FreeformAnswer[] => {
  const { aiUsers, humanUsers, rtrUsers } = answers;

  const allAnswers: FreeformAnswer[] = [];
  const showHuman = sourceFilter === All || sourceFilter === Human;
  showHuman && allAnswers.push(...humanUsers);
  const showAI = sourceFilter === All || sourceFilter === AI;
  showAI && allAnswers.push(...aiUsers);
  const showRTR = sourceFilter === All || sourceFilter === RTR;
  showRTR && allAnswers.push(...rtrUsers);

  return allAnswers;
};

const combineQuestionStats = (statsQuestions?: QuestionStats[], surveyQuestions?: Question[], summaryQuestions?: SurveySummaryQuestion[]): CombinedQuestionStats[] => {
  if (!statsQuestions || !surveyQuestions) return [];

  return statsQuestions.map((question: QuestionStats) => {
    const matchingQuestion = surveyQuestions.find(q => q.id === question.id);
    const hasFeedback = matchingQuestion?.hasFeedback || false;
    const summaries = summaryQuestions?.find(q => q.id === question.id)?.summaries;

    return { ...question, hasFeedback, summaries, questionType: matchingQuestion?.type as SurveyQuestionType };
  });
};

export { combineQuestionStats, convertCriteriaToList, feedbackListForFilter, freeformListForFilter };
